import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";
import { queryParams } from "../../../utils/helper";

export const newsletterApiService = createApi({
  reducerPath: "newsletterApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createNewsletter: builder.mutation({
      query: ({ body, params }) => {
        let query = queryParams(params);
        return {
          url: `newsletter/create${query}`,
          method: "POST",
          body,
        };
      },
    }),
  }),
});

export const { useCreateNewsletterMutation } = newsletterApiService;
